import { array } from 'fp-ts';
import { useRepositoryInfiniteQuery } from '@mews-commander/data-access';

const itemsCountPerPage = 10;

export const useCompaniesKeySearch = (searchToken: string, chainIds: string[]) =>
    useRepositoryInfiniteQuery(
        'companies',
        'keySearch',
        ({ pageParam }) => ({ searchToken, chainIds, startIndex: pageParam, count: itemsCountPerPage }),
        {
            enabled: !!searchToken && array.isNonEmpty(chainIds),
            initialPageParam: 0,
            getNextPageParam: (lastPage, allPages) =>
                lastPage.companiesByKeys.length < itemsCountPerPage ? undefined : allPages.length * itemsCountPerPage,
        }
    );
